/**
 * Add the ability for test suites to manually set support flags
 * to better test more environments.
 */
var supportsFlags = {};
export { supportsFlags };